import { render, staticRenderFns } from "./ClassSubjects.vue?vue&type=template&id=45be7f1b&"
import script from "./ClassSubjects.vue?vue&type=script&lang=ts&"
export * from "./ClassSubjects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports